import React from 'react';
import Banner from './Banner';

const About = () => {
  return (
    <>
      <Banner title="About Me" />
      <div className="flex justify-center py-4">
        <div className="timeline-container mr-2 my-4">
          <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <p className="text-sm md:text-lg lg:text-2xl font-bold text-primary">
              Nishantha K.
            </p>
            <p className="text-sm md:text-lg lg:text-xl py-2 text-secondary">
              Full Stack Engineer - PHP | Javascript | Typescript | Go
            </p>
            <p className="xs:text-xs">
              I have 6 years+ experience in software development primarily in
              large and medium scale system development and have excellent
              knowledge of the development lifecycle followed by the waterfall
              and agile methodologies.
              <br />I am self-motivated with a need-to-achieve attitude.
              <br /> I understand the end-to-end process of software development
              from creating the development plans to demonstrating the
              functionality to the external customer and supporting the customer
              through SIT/UAT phase.
            </p>
            <br />
          </div>
          <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <div className="flex lg:w-96 xl:w-96 md:w-96 justify-between">
              <IconBtn
                iconHref="//facebook.com/sweetnk"
                iconClass="fab fa-facebook"
              />
              <IconBtn
                iconHref="//twitter.com/__nishantha"
                iconClass="fab fa-twitter"
              />
              <IconBtn
                iconHref="//instagram.com/nishantha__k/"
                iconClass="fab fa-instagram"
              />
              <IconBtn
                iconHref="//linkedin.com/in/nishantha-kumara-nk"
                iconClass="fab fa-linkedin"
              />
              <IconBtn
                iconHref="//github.com/nishantha-kumara"
                iconClass="fab fa-github"
              />
              <IconBtn iconHref="tel:+94777062987" iconClass="fas fa-phone" />
              <IconBtn
                iconHref="mailto:nishantha.plus@gmail.com"
                iconClass="fas fa-envelope-open"
              />
            </div>
          </div>
          {/* <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <div className="hero-contact flex w-96 justify-between  text-secondary">
              <IconBtn
                iconHref="//facebook.com/sweetnk"
                iconClass="fab fa-facebook"
              />
              <IconBtn
                iconHref="//twitter.com/__nishantha"
                iconClass="fab fa-twitter"
              />
              <IconBtn
                iconHref="//instagram.com/nishantha__k/"
                iconClass="fab fa-instagram"
              />
              <IconBtn
                iconHref="//linkedin.com/in/nishantha-kumara-nk"
                iconClass="fab fa-linkedin"
              />
              <IconBtn
                iconHref="//github.com/nishantha-kumara"
                iconClass="fab fa-github"
              />
              <IconBtn iconHref="tel:+94777062987" iconClass="fas fa-phone" />
              <IconBtn
                iconHref="mailto:nishantha.plus@gmail.com"
                iconClass="fas fa-envelope-open"
              />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

const IconBtn = ({ iconHref, iconClass }) => {
  return (
    <a href={iconHref} target="_blank" rel="noreferrer">
      <i
        className={`${iconClass} hover:text-primary text-2xl lg:text-2xl xl:text-2xl`}
      ></i>
    </a>
  );
};

export default About;
